import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'
import { isEmpty } from 'lodash'
import { Toaster } from 'src/utils/helper/toaster'
import get from 'lodash/get'
import Content from 'src/assets/i18n/en.json'
import { sisValidationErrorsForCorruptedFiles, addDefaultPricesInSubmissionData, isEqualIgnoreCase } from 'src/utils/helper/misc'
import * as Common from 'src/utils/constants/common'
import i18n from 'src/assets/i18n/i18n'
const { t } = i18n().global

export default {
    namespaced: true,

    state() {
        return {
            ingestionsList: {},
            draftsList: {},
            // use different loading states for project and draft, helps to avoid wrong loading state
            ingestionLoading: {
                project: false,
                draft: false
            },
            ingestion: {
                search: '',
                sortBy: '',
                sortDirection: 'desc',
                page: '1',
                perPage: '20',
                ingestionType: [],
                status: []
            },
            draft: {
                search: '',
                sortBy: '',
                sortDirection: 'desc',
                page: '1',
                perPage: '20',
                ingestionType: [],
                status: 'in_work',
                binariesStatus: ''
            },
            isBinaryUploadInProgress: false,
            ingestionFormData: {},
            formDataLoading: true,
            selectedIngestionType: 'ingestion',
            paginationPageNumber: 1,
            deleteDraft: {},
            targetFoundryOptions: [],
            proceedBtnLoader: false,
            uploadingFiles: false,
            existingMd5Files: [],
            singleSubmissionData: {},
            isDeleted: false,
            isDeletedDraftTable: false,
            navBarOpen: true,
            familyTimelinesErrorStatusObj: {
                familyDetailsTimeline: false,
                typefaceDescriptionError: false,
                ingestionTags: false,
                relatedFamilies: false,
                fontInfoTimeline: false,
                editDisplayTimeline: false,
                imageTimeline: false,
                familyNoteError: false
            },
            showFileVersion: false,
            binariesData: [],
            filesWithError: [],
            avStatus: '',
            imageAVStatus: '',
            processedFiles: null,
            binariesWithSingleSubmission: {},
            getLoading: false,
            familyDetailsLoading: false,
            isNewIngestion: false,
            activeAccordionSubmissionId: '',
            saveDraftClicked: false,
            disableSaveDraft: true,
            updatePriceValueSetter: false,
            updateContractValueSetter: false,
            updateForDeletedBinaries: false,
            updateForMappedFonts: false,
            targetSubmissionforMoveFonts: {},
            moveFonts: false,
            delayGet: false,
            submitButtonClicked: false,
            ingestionSubmissionLoader: false,
            deleteMsz: get(Content, 'pages.inventory_ingestion_hub.create_edit_modal.delete'),
            images: [],
            imageIds: [],
            deletedImages: [],
            imagesWithError: [],
            pollingTimer: null,
            duplicateFilesUploaded: false,
            imageLoading: false,
            updateStyleName: false, //handles multiple style changes in Edit Display Info Modal to be reflected in Font File Info table
            updateSingleStyleName: false, //handles single style change in Edit Display Info to be reflected in Font File Info
            manualAccordionManage: {
                loader: false,
                accordion: false
            },
            showPutSubmissionLoader: false,
            mappingFamilyInProgress: false,
            familyMappingStatus: Common.FAMILY_MAPPING_STATUS.IDLE,
            mappingBinaryIds: [],
            familyMappingHadError: false,
            splitFamily: false,
            isGetBinaryInProgress: false,
            lastBinaryMappingError: false,
            inventoryIngestionSummary: {},
            binaryPollingApiStatus: false,
            isGetIngestionInProgress: false,
            timelineExpandedStates: {}, // Store timeline expanded states per submission: { submissionId: [expandedIndices] }
            activeBulkSelectionComponent: null // Track which component has active bulk selection: 'fontFile' | 'editDisplay' | null
        }
    },

    getters: {
        getIngestionsList: state => state.ingestionsList,
        getDraftIngestionsList: state => state.draftsList,
        getIngestionLoading: state => state.ingestionLoading,
        getIngestion: state => state.ingestion,
        getDraft: state => state.draft,
        getIngestionFormData: state => state.ingestionFormData,
        getFormDataLoading: state => state.formDataLoading,
        getSelectedIngestionType: state => state.selectedIngestionType,
        getPaginationPageNumber: state => state.paginationPageNumber,
        getDeleteDraft: state => state.deleteDraft,
        gettargetFoundryOptions: state => state.targetFoundryOptions,
        getFilesUploadLoader: state => state.uploadingFiles,
        getExistingFiles: state => state.existingMd5Files,
        getSubmissionData: state => state.singleSubmissionData,
        getIsDeleted: state => state.isDeleted,
        getNavBarOpen: state => state.navBarOpen,
        getFamilyTimelinesErrorStatusObj: state => state.familyTimelinesErrorStatusObj,
        getFileVersionVisibility: state => state.showFileVersion,
        getBinariesData: state => state.binariesData,
        getFilesWithError: state => state.filesWithError,
        hasAllValidated: state => {
            if (!state.binariesData || state.binariesData.length === 0) {
                return false; // Default to false when no data is present
            }
            //  Returns true if all binaries are validated.
            const validated = state.binariesData.map(b => {
                const complete = b.validationResult?.progress?.complete && b.submissionId !== '' && b.avStatus === 'true';
                return typeof complete === 'boolean' && complete === true
            })
            return validated.indexOf(false) === -1
        },
        hasAllImagesValidated: (state, getters, rootState, rootGetters) => {
            const graphicsList = rootGetters['graphics/list'];
            if (!graphicsList && graphicsList?.length === 0 && state.images.length === 0 && state.singleSubmissionData.userMetaData.imageSortorders[0].imageIds.length === 0) {
                return false; // Default to false when no data is present
            }
            const imagesList = state.images || graphicsList;
            const validated = imagesList.every(graphic =>
                graphic.avStatus !== '' &&
                graphic.resourceLocation !== '' &&
                graphic.hasOwnProperty('resourceLocation')
            );
            return validated
        },
        getBinaryUploadInProgress: state => state.isBinaryUploadInProgress,
        getAvStatus: state => state.avStatus,
        getImageAVStatus: state => state.imageAVStatus,
        getProcessedFiles: state => state.processedFiles,
        getBinariesWithSingleSubmission: state => state.binariesWithSingleSubmission,
        getLoader: state => state.getLoading,
        getIsNewIngestion: state => state.isNewIngestion,
        getActiveAccordionSubmissionId: state => state.activeAccordionSubmissionId,
        getTimelineExpandedState: (state) => (submissionId) => {
            return state.timelineExpandedStates[submissionId] || null;
        },
        getSaveDraftClicked: state => state.saveDraftClicked,
        getDisableSaveDraft: state => state.disableSaveDraft,
        getFamilyDetailsLoading: state => state.familyDetailsLoading,
        getUpdatePriceValueSetter: state => state.updatePriceValueSetter,
        getUpdateContractValueSetter: state => state.updateContractValueSetter,
        getUpdateForDeletedBinaries: state => state.updateForDeletedBinaries,
        getUpdateForMappedFonts: state => state.updateForMappedFonts,
        getTargetSubmissionforMoveFonts: state => state.targetSubmissionforMoveFonts,
        getMoveFonts: state => state.moveFonts,
        getMovingForAccordian: state => state.delayGet,
        getSubmitButtonClicked: state => state.submitButtonClicked,
        getIngestionSubmissionLoader: state => state.ingestionSubmissionLoader,
        getUpdateStyleName: state => state.updateStyleName,
        getImages: state => state.images,
        getDeletedImages: state => state.deletedImages,
        getImagesWithError: state => state.imagesWithError,
        getPollingTimer: state => state.pollingTimer,
        getImageLoading: state => state.imageLoading,
        getUpdateSingleStyleName: state => state.updateSingleStyleName,
        getManualAccordionManage: state => state.manualAccordionManage,
        getShowPutSubmissionLoader: state => state.showPutSubmissionLoader,
        getDuplicateFilesUploaded: state => state.duplicateFilesUploaded,
        getMappingFamilyInProgress: state => state.mappingFamilyInProgress,
        getFamilyMappingStatus: state => state.familyMappingStatus,
        getMappingBinaryIds: state => state.mappingBinaryIds,
        getFamilyMappingHadError: state => state.familyMappingHadError,
        getIsGetBinaryInProgress: state => state.isGetBinaryInProgress,
        getLastBinaryMappingError: state => state.lastBinaryMappingError,
        getInventoryIngestionSummary: state => state.inventoryIngestionSummary,
        getIngestionNotes: state => state.ingestionFormData?.ingestionNotes || [],
        getBinaryPollingApiStatus: state => state.binaryPollingApiStatus,
        getIsGetIngestionInProgress: state => state.isGetIngestionInProgress,
        getSplitFamily: state => state.splitFamily,
        getActiveBulkSelectionComponent: state => state.activeBulkSelectionComponent
    },

    mutations: {
        setIngestions(state, data) {
            state.ingestionsList = data
        },
        setNavBarOpen(state, val) {
            state.navBarOpen = val
        },
        setBinaryUploadInProgress(state, val) {
            state.isBinaryUploadInProgress = val
        },
        setDraftIngestions(state, data) {
            state.draftsList = data
        },
        setIngestionLoading(state, loading) {
            state.ingestionLoading = loading
        },
        setIngestion(state, data) {
            state.ingestion = data
        },
        setDraft(state, data) {
            state.draft = data
        },
        clearIngestion(state) {
            state.ingestion = {
                search: '',
                sortBy: '',
                sortDirection: 'desc',
                page: '1',
                perPage: '20',
                ingestionType: [],
                status: []
            }
        },
        clearDraft(state) {
            state.draft = {
                search: '',
                sortBy: '',
                sortDirection: 'desc',
                page: '1',
                perPage: '20',
                ingestionType: [],
                status: 'in_work',
                binariesStatus: ''
            }
        },
        setIngestionFormData(state, data) {
            state.ingestionFormData = data
        },
        setIsNewIngestion(state, data) {
            state.isNewIngestion = data
        },
        updateSubmissionStatus(state, { submissionId, isComplete }) {
            const existingSubmissionIndex = state.ingestionFormData?.submissions?.findIndex(sub => sub.submissionId === submissionId);
            if (existingSubmissionIndex !== -1) {
                state.ingestionFormData.submissions[existingSubmissionIndex].isComplete = isComplete;
            } else {
                state.ingestionFormData.submissions.push({ submissionId, isComplete });
            }
        },
        setFormDataLoading(state, loading) {
            state.formDataLoading = loading
        },
        setSelectedIngestionType(state, type) {
            state.selectedIngestionType = type
        },
        setPaginationPageNumber(state, pageNumber) {
            state.paginationPageNumber = pageNumber
        },
        setDeleteDraft(state, val) {
            state.deleteDraft = { ...val }
        },
        setTargetFoundryOptions(state, data) {
            state.targetFoundryOptions = data
        },
        setFilesUploadLoader(state, loading) {
            state.uploadingFiles = loading
        },
        setExistingFiles(state, { data, ingestionBinaries = null }) {
            // Ensure data is always an array
            const sanitizedData = Array.isArray(data) ? data : [];

            let combinedFiles = [...sanitizedData];

            // If ingestionBinaries is not provided, merge existing files
            if (!ingestionBinaries) {
                combinedFiles = [...state.existingMd5Files, ...sanitizedData];
            }

            const uniqueFiles = [];
            const seenMd5 = new Set();

            for (const file of combinedFiles) {
                if (file?.md5 && !seenMd5.has(file.md5)) {
                    seenMd5.add(file.md5);
                    uniqueFiles.push(file);
                }
            }

            // Update the state with unique files
            state.existingMd5Files = uniqueFiles;
        },
        deleteExistingFiles(state, md5Array) {
            state.existingMd5Files = state.existingMd5Files.filter(file => {
                return !md5Array.includes(file.md5.split('.')[0]);
            });
        },
        clearExistingFiles(state) {
            state.existingMd5Files = []
        },
        updatedMappedFonts(state, { selectedFontForMapping, selectedMapFontOption }) {
            const binaries = state.singleSubmissionData?.userMetaData?.binaries;
            let binaryIdsToRemove = [];

            function updateContractNumbers(binaryToUpdate, mapFontOption) {
                if (mapFontOption?.existingContractNumber) {
                    binaryToUpdate.existingContractNumber = mapFontOption.existingContractNumber;
                    binaryToUpdate.contractNumber = Array.isArray(binaryToUpdate.contractNumber) && binaryToUpdate.contractNumber.length > 0
                        ? [...new Set([...mapFontOption.existingContractNumber, ...binaryToUpdate.contractNumber])]
                        : mapFontOption.existingContractNumber;
                }
            }

            function updatePrices(binaryToUpdate, binaryToUpdateWith, binaries) {
                if (binaryToUpdateWith?.prices?.[0]?.price) {
                    const doubleFormatBinary = binaries.find(
                        binary => binary.uniqueName === binaryToUpdate.uniqueName && binary.binaryId !== binaryToUpdate.binaryId
                    );
                    const price = binaryToUpdate.prices ? binaryToUpdate.prices[0].price : 0;
                    const maxPrice = Math.max(binaryToUpdateWith.prices[0]?.price, price);
                    binaryToUpdate.prices[0].currency = Common.DEFAULT_CURRENCY;
                    binaryToUpdate.prices[0].price = maxPrice;
                    if (doubleFormatBinary) {
                        doubleFormatBinary.prices[0].currency = Common.DEFAULT_CURRENCY;
                        doubleFormatBinary.prices[0].price = maxPrice;
                    }
                }
            }

            selectedFontForMapping.forEach((font, index) => {
                const binaryToUpdate = binaries.find(binary => binary.binaryId === font.binaryId);
                const mapFontOption = selectedMapFontOption[index];
                if (!binaryToUpdate) {
                    return; // Skip if binary not found
                }

                // Check if this is a 'Keep this as new' selection
                // For 'Keep this as new', the mapFontOption will be the original font data without a mapping binaryId
                const isKeepAsNew = !mapFontOption?.binaryId || mapFontOption.binaryId === font.binaryId;
                
                if (isKeepAsNew) {
                    // For 'Keep this as new', just ensure the font remains as 'new' status
                    // Don't update contract numbers, prices, or mark for removal
                    if (binaryToUpdate.status !== 'new') {
                        binaryToUpdate.status = 'new';
                    }
                } else {
                    // Regular mapping logic
                    const binaryToUpdateWith = binaries.find(binary => binary.binaryId === mapFontOption.binaryId);
                    if (mapFontOption && binaryToUpdateWith) {
                        updateContractNumbers(binaryToUpdate, mapFontOption);
                        updatePrices(binaryToUpdate, binaryToUpdateWith, binaries);
                        binaryToUpdate.status = 'updated';
                        binaryToUpdate.oldBinary = mapFontOption.binaryId;
                        binaryToUpdate.uniqueName = mapFontOption.uniqueName;
                        binaryToUpdate.styleName = mapFontOption.styleName;
                        binaryIdsToRemove.push(mapFontOption.binaryId);
                    }
                }
            });

            // Only remove binaries that were actually mapped (not 'keep as new')
            if (binaryIdsToRemove.length > 0) {
                state.singleSubmissionData.userMetaData.binaries = binaries.filter(
                    binary => !binaryIdsToRemove.includes(binary.binaryId)
                );
            }
        },
        updatePriceValue(state, { selectedRowBinaryId, priceValue }) {
            const binaries = state.singleSubmissionData?.userMetaData?.binaries;
            if (!Array.isArray(selectedRowBinaryId) || !binaries?.length) return;
            binaries.forEach((binary) => {
                if (selectedRowBinaryId.includes(binary.binaryId)) {
                    if (!binary.prices?.[0]) {
                        binary.prices = [{
                            price: (priceValue || 0),
                            currency: Common.DEFAULT_CURRENCY
                        }];
                    } else {
                        binary.prices[0].price = (priceValue || 0);
                        binary.prices[0].currency = Common.DEFAULT_CURRENCY;
                    }
                }
            });
        },

        updateDesigners(state, desingerDetails) {
            const binaries = state.singleSubmissionData?.userMetaData;
            if (binaries) {
                binaries.designers = desingerDetails
            }
        },

        updateTags(state, tags) {
            const binaries = state.singleSubmissionData?.userMetaData;
            if (binaries) {
                binaries.tags = tags
            }
        },

        updateExcludedAiTags(state, tags) {
            if (state.singleSubmissionData) {
                state.singleSubmissionData.excludedAiTags = tags
            }
        },

        updateStyleName(state, { selectedRowBinaryId, styleName }) {
            const binaries = state.singleSubmissionData?.userMetaData?.binaries;
            if (!Array.isArray(selectedRowBinaryId) || !binaries?.length) return;
            for (let i = 0; i < selectedRowBinaryId.length; i++) {
                const binaryId = selectedRowBinaryId[i];
                const binary = binaries.find(b => b.binaryId === binaryId);
                const associatedBinariesWithSameStyleName = binaries.filter(b => isEqualIgnoreCase(b.styleName, binary.styleName));
                for (const element of associatedBinariesWithSameStyleName) {
                    element.styleName = styleName[i];
                }
            }
        },

        deleteFileInformation(state, binaryIdArray) {
            if (state.singleSubmissionData?.userMetaData?.binaries) {
                state.singleSubmissionData.userMetaData.binaries = state.singleSubmissionData.userMetaData.binaries.filter(
                    binary => !binaryIdArray.includes(binary.binaryId)
                );
            }
        },
        deleteFamilyAccordian(state, submissionId) {
            if (state.binariesWithSingleSubmission.hasOwnProperty(submissionId)) {
                delete state.binariesWithSingleSubmission[submissionId];
            }
        },
        setSingleSubmissionData(state, data) {
            state.singleSubmissionData = { ...state.singleSubmissionData, ...data }
        },
        updateSubmissionData(state, { path, value, binaryId, replaceArray = false }) {
            let updatedState = { ...state.singleSubmissionData };

            // Traverse the path and update the target value
            path.reduce((acc, part, index) => {
                if (index === path.length - 1) {
                    if (Array.isArray(acc[part]) && !replaceArray) {
                        // If binaryId is provided, find the object with the matching binaryId
                        if (binaryId) {
                            const indexToUpdate = acc[part].findIndex(item => item.binaryId === binaryId);

                            // If the binaryId is found, update the corresponding item
                            if (indexToUpdate !== -1) {
                                acc[part][indexToUpdate] = { ...acc[part][indexToUpdate], ...value }; // Merge the updated value
                            }
                        } else {
                            // If no binaryId is provided, update all elements in the array
                            acc[part] = acc[part].map(item => ({ ...item, ...value }));
                        }
                    } else {
                        acc[part] = value; // Directly update the value if it's not an array or if replaceArray is true
                    }
                } else {
                    // If the part does not exist, create an empty object for it
                    acc[part] = acc[part] || {};
                }
                return acc[part];
            }, updatedState);

            state.singleSubmissionData = updatedState;
        },
        setIsDeleted(state, val) {
            state.isDeleted = val
        },
        setShowVersions(state, val) {
            state.showFileVersion = val
        },
        setIsDeletedTable(state, val) {
            state.isDeletedDraftTable = val
        },
        setFamilyTimelinesErrorStatusObj(state, statusObj) {
            state.familyTimelinesErrorStatusObj = { ...state.familyTimelinesErrorStatusObj, ...statusObj }
        },
        resetFamilyTimelinesErrorStatusObj(state) {
            state.familyTimelinesErrorStatusObj = {
                displayFamilyName: false,
                familyPrice: false,
                publishDate: false,
                familyDesigners: false,
                ingestionTags: false,
                relatedFamilies: false,
                typefaceDescriptionError: false,
                fontInfoContractName: false,
                fontInfoContractNameEmpty: false,
                editDisplayStyleName: false,
                editDisplayPrice: false,
                editDisplayPriceEmpty: false,
                images: false,
                familyNoteError: false
            }
        },
        setBinariesData(state, data) {
            state.binariesData = data
        },
        deleteBinariesData(state, md5Array) {
            md5Array.forEach(md5 => {
                state.binariesData = state.binariesData.filter(binary => binary.md5Checksum !== md5)
            })
        },
        updateProcessedFiles(state, md5Array) {
            state.processedFiles = state.processedFiles - md5Array.length
        },
        setFilesWithError(state, data) {
            const fileExists = state.filesWithError.some(file => file.name === data.name && file.message === data.message);
            if (!fileExists) {
                state.filesWithError.push(data);
            }
        },
        clearFilesWithError(state) {
            state.filesWithError = []
        },
        setAvStatus(state, data) {
            state.avStatus = data
        },
        setImageAVStatus(state, data) {
            state.imageAVStatus = data
        },
        setProcessedFiles(state, data) {
            state.processedFiles = data
        },
        setBinariesWithSingleSubmission(state, data) {
            state.binariesWithSingleSubmission = data
        },
        setGetLoading(state, data) {
            state.getLoading = data
        },
        clearSubmissionData(state) {
            state.singleSubmissionData = {}
        },
        clearBinariesWithSingleSubmission(state) {
            state.binariesWithSingleSubmission = {}
        },
        setActiveAccordionSubmissionId(state, id) {
            state.activeAccordionSubmissionId = id
        },
        setTimelineExpandedState(state, { submissionId, expandedIndices }) {
            state.timelineExpandedStates = {
                ...state.timelineExpandedStates,
                [submissionId]: expandedIndices
            };
        },
        setSaveDraftClicked(state, val) {
            state.saveDraftClicked = val
        },
        setDisableSaveDraft(state, val) {
            state.disableSaveDraft = val
        },
        setFamilydetailsLoading(state, data) {
            state.familyDetailsLoading = data
        },
        setUpdatePriceValueSetter(state, data) {
            state.updatePriceValueSetter = data
        },
        setUpdateContractValueSetter(state, data) {
            state.updateContractValueSetter = data
        },
        setUpdateForDeletedBinaries(state, data) {
            state.updateForDeletedBinaries = data
        },
        setUpdateForMappedFonts(state, data) {
            state.updateForMappedFonts = data
        },
        setSubmitButtonClicked(state, data) {
            state.submitButtonClicked = data
        },
        setIngestionSubmissionLoader(state, data) {
            state.ingestionSubmissionLoader = data
        },
        setUpdateStyleName(state, data) {
            state.updateStyleName = data
        },
        setTargetSubmissionforMoveFonts(state, data) {
            state.targetSubmissionforMoveFonts = { ...state.targetSubmissionforMoveFonts, ...data }
        },
        clearTargetSubmissionforMoveFonts(state) {
            state.targetSubmissionforMoveFonts = {}
        },
        setMoveFonts(state, data) {
            state.moveFonts = data
        },
        setMovingForAccordian(state, data) {
            state.delayGet = data
        },
        setImages(state, data) {
            if (data.length === 0) {
                state.images = [];
                return;
            }

            const imageIds = state.singleSubmissionData?.userMetaData?.imageSortorders[0]?.imageIds;

            // Use a Set for quick lookup of imageIds
            const imageIdSet = new Set(imageIds);

            // Separate matched and unmatched images
            const matchedImgs = [];
            const unmatchedImgs = [];

            data.forEach((img) => {
                if (imageIdSet.has(img.id)) {
                    matchedImgs.push(img);
                } else {
                    unmatchedImgs.push(img);
                }
            });

            // Ensure matched images are in the same order as imageIds
            matchedImgs.sort((a, b) => imageIds.indexOf(a.id) - imageIds.indexOf(b.id));

            // Assign state.images based on unmatchedImgs length
            state.images = unmatchedImgs.length > 0 ? [...matchedImgs, ...unmatchedImgs] : matchedImgs;
        },
        removeImage(state, data) {
            //check for the empty state when to do that
            state.images = state.images.filter(image => image.id !== data)
            state.deletedImages = [...state.deletedImages, data]
        },
        setMalwareImages(state, data) {
            state.imagesWithError = data
        },
        setPollingTimer(state, timer) {
            state.pollingTimer = timer;
        },
        setImageLoading(state, loading) {
            state.imageLoading = loading;
        },
        setUpdateSingleStyleName(state, data) {
            state.updateSingleStyleName = data
        },
        setManualAccordionManage(state, data) {
            state.manualAccordionManage = data
        },
        setShowPutSubmissionLoader(state, data) {
            state.showPutSubmissionLoader = data
        },
        setDuplicateFilesUploaded(state, data) {
            state.duplicateFilesUploaded = data
        },
        setMappingFamilyInProgress(state, data) {
            state.mappingFamilyInProgress = data
        },
        setFamilyMappingStatus(state, data) {
            state.familyMappingStatus = data
        },
        setMappingBinaryIds(state, data) {
            state.mappingBinaryIds = data
        },
        setFamilyMappingHadError(state, data) {
            state.familyMappingHadError = data
        },
        resetFamilyMappingState(state) {
            state.familyMappingStatus = Common.FAMILY_MAPPING_STATUS.IDLE
            state.mappingBinaryIds = []
            state.familyMappingHadError = false
            state.mappingFamilyInProgress = false
            state.isGetBinaryInProgress = false
            state.lastBinaryMappingError = false
        },
        setIsGetBinaryInProgress(state, data) {
            state.isGetBinaryInProgress = data
        },
        setLastBinaryMappingError(state, data) {
            state.lastBinaryMappingError = data
        },
        setInventoryIngestionSummary(state, data) {
            state.inventoryIngestionSummary = data
        },
        setIngestionNotes(state, notes) {
            // Ensure notes is always an array of objects with proper structure
            if (Array.isArray(notes)) {
                state.ingestionFormData.ingestionNotes = notes.map(note => ({
                    note: note.note || '',
                    language: note.language || 'en'
                }));
            } else {
                state.ingestionFormData.ingestionNotes = [];
            }
        },
        setBinaryPollingApiStatus(state, data) {
            state.binaryPollingApiStatus = data
        },
        setIsGetIngestionInProgress(state, data) {
            state.isGetIngestionInProgress = data
        },
        setSplitFamily(state, data) {
            state.splitFamily = data
        },
        setActiveBulkSelectionComponent(state, componentName) {
            state.activeBulkSelectionComponent = componentName
        }
    },

    actions: {
        getInventoryIngestionData({ commit, state }, obj) {
            const updateIngestionLoading = (type, isLoading) => {
                state.ingestionLoading = {
                    ...state.ingestionLoading,
                    [type]: isLoading
                };
            };

            const resetIngestionList = (type) => {
                if (type === 'draft') {
                    state.draftsList = { ...state.draftsList, collection: [] };
                } else {
                    state.ingestionsList = { ...state.ingestionsList, collection: [] };
                }
            };

            const handleResponse = (type, data) => {
                if (type === 'draft') {
                    commit('setDraftIngestions', data);
                } else {
                    commit('setIngestions', data);
                }
                updateIngestionLoading(type, false);
            };

            const objToUse = obj.status === 'in_work' ? state.draft : state.ingestion;
            const cleanedIngestionObj = Object.keys(objToUse).reduce((acc, key) => {
                if (objToUse[key] !== '' && !isEmpty(objToUse[key])) {
                    acc[key] = objToUse[key];
                }
                return acc;
            }, {});
            const { search, sortBy, sortDirection, page, perPage, ingestionType, status, binariesStatus } = cleanedIngestionObj;

            const type = obj.status === 'in_work' ? 'draft' : 'project';
            updateIngestionLoading(type, true);
            resetIngestionList(type); // reset the list before fetching new data, helps to avoid flickering

            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.getInventoryIngestionData(search, sortBy, sortDirection, page, perPage, ingestionType, status, binariesStatus)
                    .then(response => {
                        handleResponse(type, response.data);

                        if (state.isDeleted) {
                            Toaster.notifySuccess('Draft discarded');
                            commit('setIsDeleted', false);
                        }

                        if (state.isDeletedDraftTable) {
                            Toaster.notifySuccess(`"${state.deleteDraft.draftName}"` + state.deleteMsz);
                            commit('setIsDeletedTable', false);
                        }

                        return resolve(response.data);
                    })
                    .catch((error) => {
                        updateIngestionLoading(type, false);
                        const err = Errors.create(error);
                        reject(err);
                    });
            });
        },

        getInventoryIngestionDataById({ commit }, id) {
            commit('setIsGetIngestionInProgress', true)
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.getInventoryIngestionById(id)
                    .then(response => {
                        commit('setIngestionFormData', response.data)
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        commit('setFormDataLoading', false)
                        const err = Errors.create(error)
                        reject(err)
                    }).finally(() => {
                        commit('setBinaryPollingApiStatus', false);
                        commit('setIsGetIngestionInProgress', false);
                    })
            })
        },

        deleteInventoryIngestionById({ commit }, id) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.deleteInventoryIngestion(id)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },

        createInventoryIngestion({ commit }, reqObj) {
            commit('clearSubmissionData')
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.createInventoryIngestion(reqObj)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err);
                    })
            })
        },

        patchInventoryIngestion({ commit }, reqObj) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.patchInventoryIngestion(reqObj.ingestionId, reqObj)
                    .then(response => {
                        commit('setIngestionFormData', response.data.inventoryIngestion)
                        
                        // Update the ingestion notes in the store if they were included in the request
                        if (reqObj.ingestionNotes) {
                            commit('setIngestionNotes', reqObj.ingestionNotes);
                        }
                        
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err);
                    })
            })
        },

        getSingleSubmissionData({ commit }, singleSubmissionParams) {
            if (!singleSubmissionParams?.moveFonts) {
                commit('setFamilydetailsLoading', true)
            }
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.getInventoryIngestionSubmissions(singleSubmissionParams.ingestionId, singleSubmissionParams.firstSubmissionId)
                    .then(response => {
                        if (!singleSubmissionParams?.moveFonts) {
                            // this is to add default prices in submission data, if prices are not present
                            addDefaultPricesInSubmissionData(response.data)
                            commit('setSingleSubmissionData', response.data)
                            commit('setFamilydetailsLoading', false)
                        } else {
                            commit('setTargetSubmissionforMoveFonts', response.data)
                        }
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        commit('setFamilydetailsLoading', false)
                        const err = Errors.create(error)
                        reject(err)
                    })
                    .finally(() => {
                        commit('setSplitFamily', false)
                    })
            })
        },

        updateInventoryIngestionSubmission({ commit }, payload) {
            const { inventoryIngestionId, submissionId, reqObj, moveFonts } = payload;
            commit('setMovingForAccordian', true)
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.updateIngestionSubmission(inventoryIngestionId, submissionId, reqObj)
                    .then(response => {
                        // This code sets the submission status in the ingestion form data, after moving the file
                        if (response?.data?.status === 'Success' && response?.data?.submission?.id) {
                            commit('updateSubmissionStatus', { submissionId: response?.data?.submission?.id, isComplete: true })
                        } else if (response?.data?.status === 'partial success') {
                            commit('updateSubmissionStatus', { submissionId: response?.data?.submission?.id, isComplete: false })
                        }
                        if (moveFonts) {
                            commit('setMoveFonts', true)
                        } else {
                            commit('setMoveFonts', false)
                        }
                        commit('setMovingForAccordian', false)
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        commit('setMoveFonts', false)
                        commit('setMovingForAccordian', false)
                        const err = Errors.create(errorResponse)
                        reject(err)
                    })
            })
        },

        async updateInventoryIngestionSubmissionBulk(_, dataObj) {
            try {
                const { inventoryIngestionId, payload } = dataObj;
                const response = await Api.InventoryIngestionSubmissions.bulkFamilyUpdate(inventoryIngestionId, payload)
                return {
                    success: true,
                    data: response.data.data
                }
            } catch (error) {
                console.error('error', error)
                return {
                    success: false,
                    error: error?.response?.data?.error || error
                }
            }
        },

        showVersion({ commit }) {
            commit('setShowVersions', true);
        },
        hideVersion({ commit }) {
            commit('setShowVersions', false);
        },
        postIngestionBinaries({ commit }, reqObj) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionBinaries.uploadBinary(reqObj.inventoryIngestionId, reqObj.binariesData)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },

        deleteSubmission({ commit, state, dispatch }, singleSubmissionParams) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.deleteSubmission(singleSubmissionParams.ingestionId, singleSubmissionParams.submissionId)
                    .then(response => {
                        commit('deleteFamilyAccordian', singleSubmissionParams.submissionId)
                        if (singleSubmissionParams?.md5Array?.length) {
                            commit('deleteExistingFiles', singleSubmissionParams.md5Array);
                        }
                        const submissionIndex = state.ingestionFormData?.submissions?.findIndex(sub => sub.submissionId === singleSubmissionParams.submissionId);
                        if (submissionIndex !== -1) {
                            const updatedSubmissions = [...state.ingestionFormData.submissions];
                            updatedSubmissions.splice(submissionIndex, 1);
                            state.ingestionFormData.submissions = updatedSubmissions;
                        }
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        unlinkSubmission({ commit, state }, singleSubmissionParams) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.unlinkSubmission(singleSubmissionParams.ingestionId, singleSubmissionParams.submissionId)
                    .then(response => {
                        let newBinariesData = state.binariesData.filter(binary => binary.submissionId !== singleSubmissionParams.submissionId);
                        const md5ChecksumArray = state.binariesData
                            .filter(binary => binary.submissionId === singleSubmissionParams.submissionId)
                            .map(binary => binary.md5Checksum);

                        //updates the binariesData and uploaded md5's with the new data
                        commit('setBinariesData', newBinariesData);
                        commit('deleteExistingFiles', md5ChecksumArray);

                        const totalCompleteFiles = state.binariesData.filter(binary => binary?.validationResult?.progress?.complete && binary?.submissionId !== '')?.length;
                        commit('setProcessedFiles', totalCompleteFiles);
                        commit('deleteFamilyAccordian', singleSubmissionParams.submissionId)
                        const submissionIndex = state.ingestionFormData?.submissions?.findIndex(sub => sub.submissionId === singleSubmissionParams.submissionId);
                        if (submissionIndex !== -1) {
                            const updatedSubmissions = [...state.ingestionFormData.submissions];
                            updatedSubmissions.splice(submissionIndex, 1);
                            state.ingestionFormData.submissions = updatedSubmissions;
                        }
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        getIngestionBinaries({ commit, dispatch, state }, inventoryIngestionId) {
            return new Promise((resolve, reject) => {
                commit('setGetLoading', true);
                Api.InventoryIngestionBinaries.getIngestionBinaries(inventoryIngestionId)
                    .then(async (response) => {
                        let deletedBinaries = response.data.binaries.filter(binary => binary.status === 'deleted');
                        response.data.binaries = response.data.binaries.filter(binary => binary.status !== 'deleted');
                        commit('setBinariesData', response.data.binaries);
                        commit('setLastBinaryMappingError', false);
                        // To retain error in the error Popup
                        deletedBinaries.forEach(binary => {
                            if (response.data.binaries.some(b => b.md5Checksum === binary.md5Checksum)) {
                                return;
                            }
                            if (binary?.avStatus == 'false' || binary?.validationResult?.errorLevel == 'ERROR') {
                                commit('setFilesWithError',
                                    {
                                        name: binary.fileName,
                                        error: sisValidationErrorsForCorruptedFiles(binary)
                                    }
                                );
                            }
                        });

                        if (response.data.binaries.length === 0) {
                            //when no binaries are present
                            state.ingestionFormData.submissions = [];
                            if (state.filesWithError.length > 0) {
                                commit('clearBinariesWithSingleSubmission');
                                commit('setLastBinaryMappingError', true);
                            }
                            else {
                                commit('setLastBinaryMappingError', false);
                            }
                            commit('setGetLoading', false);
                            commit('setExistingFiles', {
                                data: [],
                                ingestionBinaries: true
                            }
                            );
                            return;
                        }
                        let submissionIds = {}
                        let deletingBinariesIds = [];
                        let deletingBinariesMd5 = [];
                        response.data.binaries.forEach(binary => {
                            if (binary?.avStatus == 'false' || binary?.validationResult?.errorLevel == 'ERROR') {
                                deletingBinariesIds.push(binary.id);
                                deletingBinariesMd5.push(binary.md5Checksum);
                                if (state.mappingFamilyInProgress && state.mappingBinaryIds.includes(binary.id)) {
                                    commit('setFamilyMappingHadError', true);
                                }
                                commit('setFilesWithError',
                                    {
                                        name: binary.fileName,
                                        error: sisValidationErrorsForCorruptedFiles(binary)
                                    }
                                );
                            }
                            if (binary?.avStatus == 'false') {
                                commit('setAvStatus', false);
                            }
                            if (binary?.submissionId && (binary?.validationResult?.errorLevel !== 'ERROR')) {
                                if (!submissionIds[binary.submissionId]) {
                                    submissionIds[binary.submissionId] = [binary];
                                } else {
                                    submissionIds[binary.submissionId].push(binary);
                                }
                            }
                        });
                        if (deletingBinariesIds.length > 0) {
                            const deleteReqObj = {
                                inventoryIngestionId: inventoryIngestionId,
                                binaries: {
                                    binaries: deletingBinariesIds
                                },
                                md5Array: deletingBinariesMd5
                            }
                            await dispatch('deleteIngestionBinaries', deleteReqObj);
                        }
                        if (Object.keys(submissionIds).length > 0) {
                            commit('setBinariesWithSingleSubmission', submissionIds);
                        }
                        const allFilesHaveTrueAvStatus = response.data.binaries.every(binary => binary.avStatus == 'true');
                        if (allFilesHaveTrueAvStatus) {
                            if (state.avStatus === 'scanning') {
                                commit('setAvStatus', true);
                            }
                        }

                        const totalCompleteFiles = response.data.binaries.filter(binary => binary?.validationResult?.progress?.complete && binary?.submissionId !== '').length;
                        commit('setProcessedFiles', totalCompleteFiles);
                        commit('setExistingFiles', {
                            data: response.data.binaries.map(binary => {
                                return {
                                    md5: binary.md5Checksum + '.' + binary.fileType,
                                    file: {
                                        name: binary.fileName,
                                        size: binary.fileSize
                                    }
                                }
                            }),
                            ingestionBinaries: true
                        });
                        return resolve(response.data);
                    })
                    .catch((error) => {
                        const err = Errors.create(error);
                        reject(err);
                    });
            });
        },
        deleteIngestionBinaries({ commit, state, dispatch }, reqObj) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionBinaries.deleteBinaries(reqObj.inventoryIngestionId, reqObj.binaries)
                    .then(response => {
                        commit('deleteFileInformation', reqObj.binaries.binaries);
                        commit('deleteExistingFiles', reqObj.md5Array);
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        callDeleteIngesionBinaries({ commit, state, dispatch }, reqObj) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionBinaries.deleteBinaries(reqObj.inventoryIngestionId, reqObj.binaries)
                    .then(response => {
                        commit('deleteFileInformation', reqObj.binaries.binaries);
                        commit('deleteExistingFiles', reqObj.md5Array);
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        patchUpdateInventoryIngestionStatus({ commit }, ingestionId) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.updateInventoryIngestionStatus(ingestionId)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        const err = Errors.create(errorResponse)
                        reject(err);
                    })
            })
        },

        deleteImage({ commit }, { imageId, submissionId }) {
            return new Promise((resolve, reject) => {
                commit('removeImage', imageId)
                Api.Images.deleteImage(imageId, submissionId)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch(error => {
                        const err = Errors.create(error)
                        commit('errors/add', err)
                        reject(err)
                    })
            })
        },

        getImagesAvStatus({ commit, dispatch, getters, state }, submissionId) {
            commit('setImageLoading', true);
            return new Promise((resolve, reject) => {
                Api.Images.getImages(submissionId)
                    .then((response) => {
                        const images = response.data.collection || [];
                        commit('setImages', images);
                        let hasFailedImages = false;
                        let hasBlankAvStatus = false;
                        let allImagesValid = true;
                        const failedImages = [];

                        for (const image of images) {
                            if (image.avStatus === 'false') {
                                hasFailedImages = true;
                                failedImages.push(image);
                                allImagesValid = false; // If there's a failed image, set to false
                            }
                            if (image.avStatus === '') {
                                hasBlankAvStatus = true;
                                allImagesValid = false;
                            }
                        }
                        if (hasFailedImages) {
                            commit('setMalwareImages', failedImages);

                            // **Bulk delete failed images to reduce API calls**
                            Promise.all(
                                failedImages.map(file =>
                                    dispatch('deleteImage', { imageId: file.id, submissionId })
                                )
                            ).then(() => {
                                commit('setImageAVStatus', 'failed');
                            });
                        }
                        if (allImagesValid && state.images.length > 0) {
                            commit('setImageAVStatus', 'success');
                            commit('setMalwareImages', []);
                        } else if (hasBlankAvStatus) {
                            commit('setImageAVStatus', 'scanning'); // If there are blank statuses, scanning is still in progress
                        }

                        // **Implement Polling Mechanism**
                        if (!getters.hasAllImagesValidated) {
                            if (getters.getPollingTimer) {
                                clearTimeout(getters.getPollingTimer); // Clear any existing timer
                            }
                            const timer = setTimeout(() => {
                                dispatch('getImagesAvStatus', submissionId);
                            }, 5000); // Retry after 5 seconds

                            commit('setPollingTimer', timer); // Store timeout ID in Vuex
                        } else {
                            commit('setImageLoading', false);
                            const imageIds = state.images.map(image => image.id)
                            commit('setSingleSubmissionData', {
                                userMetaData: {
                                    ...state.singleSubmissionData.userMetaData,
                                    imageSortorders: [{
                                        imageIds: imageIds,
                                        locationIso: Common.DEFAULT_LOCATION
                                    }]
                                }
                            })
                            if (getters.getPollingTimer) {
                                clearTimeout(getters.getPollingTimer); // Clear the polling timer when done
                                commit('setPollingTimer', null);
                            }
                        }


                        resolve(response);
                    })
                    .catch((error) => {
                        const err = Errors.create(error);
                        commit('setImageLoading', false);
                        if (getters.getPollingTimer) {
                            clearTimeout(getters.getPollingTimer);
                            commit('setPollingTimer', null);
                        }
                        commit('errors/add', err);
                        reject(err);
                    });
            });
        },

        getContractDetails({ commit }, contractNumbers) {
            return new Promise((resolve, reject) => {
                Api.Contract.getContractNumbersDetail(contractNumbers)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        const err = Errors.create(errorResponse)
                        reject(err);
                    })
            })
        },
        
        getFamilyDetails({ commit }, familyId) {
            return new Promise((resolve, reject) => {
                Api.Families.getFamilyDetails(familyId)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        const err = Errors.create(errorResponse)
                        reject(err);
                    })
            })
        },

        mapFamilyWithExisting({ commit }, payload) {
            const { inventoryIngestionId, bodyRequest } = payload;
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.mapFamilyWithExisting(inventoryIngestionId, bodyRequest)
                .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        const err = Errors.create(errorResponse)
                        if (error.response.status === Common.FAMILY_LOCKED_FOR_EDIT_ERROR_CODE) {
                            Toaster.notifyError(error.response.data.error.message)
                        } else {
                            const msg = typeof errorResponse.message === 'string' ? errorResponse.message : t('api.errors.map_family_error')
                            Toaster.notifyError(msg)
                        }
                        reject(err)
                    })
            })
        },

        createNewFamily({ commit }, payload) {
            const { inventoryIngestionId, submissionId, bodyRequest } = payload;
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionSubmissions.createNewFamily(inventoryIngestionId, submissionId, bodyRequest)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const errorResponse = error.response ? { message: error.response?.data?.error } : error;
                        const err = Errors.create(errorResponse)
                        reject(err)
                    })
            })
        },
        onlyGetIngestionBinaries({ commit, dispatch, state }, inventoryIngestionId) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionBinaries.getIngestionBinaries(inventoryIngestionId)
                    .then(response => {
                        commit('setBinariesData', response.data.binaries);
                        return resolve(response.data.binaries)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        getInventoryIngestionSummary({ commit }, inventoryIngestionId) {
            return new Promise((resolve, reject) => {
                Api.InventoryIngestion.getInventoryIngestionSummary(inventoryIngestionId)
                    .then(response => {
                        commit('setInventoryIngestionSummary', response.data)
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },

        /**
         * Download binaries for a specific submission in inventory ingestion
         * @param {Object} payload - Object containing inventoryIngestionId and submissionId
         * @returns {Promise} Promise that resolves with the download URL
         */
        downloadInventoryIngestionBinaries({ commit }, payload) {
            const { inventoryIngestionId, submissionId } = payload;
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionDownloads.getBinariesZip(inventoryIngestionId, submissionId)
                    .then(response => {
                        resolve(response.data.url)
                    })
                    .catch((error) => {
                        commit('errors/add', Errors.create(error))
                        reject(new Error(error))
                    })
            })
        },

        /**
         * Download images for a specific submission in inventory ingestion
         * @param {Object} payload - Object containing inventoryIngestionId and submissionId
         * @returns {Promise} Promise that resolves with the download URL
         */
        downloadInventoryIngestionImages({ commit }, payload) {
            const { inventoryIngestionId, submissionId } = payload;
            return new Promise((resolve, reject) => {
                Api.InventoryIngestionDownloads.getImagesZip(inventoryIngestionId, submissionId)
                    .then(response => {
                        resolve(response.data.url)
                    })
                    .catch((error) => {
                        commit('errors/add', Errors.create(error))
                        reject(new Error(error))
                    })
            })
        },
    },
    modules: {
        errors: VuexErrors
    }
}
